<template>
    <div class="lg:container" id="list" v-touch:swipe.right="previous" v-touch:swipe.left="next">
          <div class="list-title">
              <div class="left" :class="{ inactive: ! previousAvailable }" @click="previous">‹</div>
              <div class="center">
                  {{ day }}
                  <div class="text-2xl">{{ weekday }}</div>
              </div>
              <div class="right" :class="{ inactive: ! nextAvailable }" @click="next">›</div>
          </div>
        <div class="dayprediction">
            <div class="intervals text-center">
              <div class="text-left" v-for="action in actionsShow" :key="action">
                  <div v-for="(interval, index) in dayIntervals(action)" :key="index">
                    <component v-bind:is="actionIcon(action)" 
                      height="16" :classes="'icon '+(interval.quality > 0 ? 'good' : 'bad')" />
                    {{ $t(action) }} <nobr>{{ formatTime(interval.start) }} - {{ formatTime(interval.end) }}</nobr>
                  </div>
              </div>
              <Muhurtas />
              <ActionSelector v-if="canUse('day-predictions-unlimited')" />
            </div>
            <div class="prediction">
              <TimezoneWarning :day="current.day" />
              <span class=""  v-html="dayPrediction"></span>
            </div>
        </div>
        <PageBlock classes="sm:w-1/2 sm:m-auto" v-if="! canUse('day-predictions-unlimited')">
            <UpgradePrompt />
        </PageBlock>
    </div>
</template>

<script>
import { TimeFormatMixin } from '@/components/visual/TimeFormatMixin'
import TimezoneWarning from '@/components/dayprediction/TimezoneWarning'
import Muhurtas from '@/components/dayprediction/Muhurtas'
import IconPersonal from '@/components/visual/icons/actions/IconPersonal'
import IconGraph from '@/components/visual/icons/IconGraph'
import IconHaircut from '@/components/visual/icons/actions/IconHaircut'
import IconManicure from '@/components/visual/icons/actions/IconManicure'
import IconClothes from '@/components/visual/icons/actions/IconClothes'
import IconTravel from '@/components/visual/icons/actions/IconTravel'
import IconTakecredit from '@/components/visual/icons/actions/IconTakecredit'
import IconGivecredit from '@/components/visual/icons/actions/IconGivecredit'
import UpgradePrompt from '@/components/visual/UpgradePrompt'
import PageBlock from '@/components/visual/PageBlock'
import ActionSelector from '@/components/visual/ActionSelector'
import { mapState, mapGetters } from 'vuex'
export default {
  components: { TimezoneWarning, Muhurtas, IconGraph, IconHaircut, IconManicure, IconClothes, IconTravel, IconTakecredit, IconGivecredit, IconPersonal, UpgradePrompt, PageBlock, ActionSelector },
  mixins: [TimeFormatMixin],
  data() {
    return {
    }
  },
  created() {
    this.setDay()
  },
  computed: {
    actionsShow() {
        return this.actions.filter(action => this.actionsOn[action])
    },
    day() {
        return this.current.day.getDate() + ' ' + this.$t('month' + (this.current.day.getMonth() + 1))
    },
    weekday() {
        return this.$t('day' + (this.current.day.getDay() + 1))
    },
    previousAvailable() {
        if (! this.dayAvailable(this.previousDay.getDate()))
          return false
        return this.previousDay.getMonth() > this.firstAvailableDate.getMonth()
          || this.previousDay.getMonth() == this.firstAvailableDate.getMonth() && this.previousDay.getDate() >= this.firstAvailableDate.getDate()
    },
    nextAvailable() {
        return this.dayAvailable(this.nextDay.getDate())
    },
    ...mapState('predictions', ['daypredictions', 'days', 'actions', 'actionsOn', 'current']),
    ...mapGetters('predictions', ['dayPrediction', 'dayIntervals', 'actionIcon', 'nextDay', 'previousDay', 'firstAvailableDate', 'dayAvailable']),
    ...mapGetters('auth', ['canUse']),
  },
  methods: {
    next() {
      if (this.nextAvailable)
        this.$store.dispatch('predictions/setNextDay')
    },
    previous() {
      if (this.previousAvailable)
        this.$store.dispatch('predictions/setPreviousDay')
    },
    calendar() {
      this.$router.push({ name: 'calendar' })
    },
    setDay() {
      this.$store.dispatch('predictions/setCurrentDay', this.$route.params.day)
    },
  },
  watch: {
    '$route': 'setDay',
  },
}
</script>

<i18n locale="ru" lang="yaml">
  noprediction: "Нет прогноза на этот день"
  month1: "января"
  month2: "февраля"
  month3: "марта"
  month4: "апреля"
  month5: "мая"
  month6: "июня"
  month7: "июля"
  month8: "августа"
  month9: "сентября"
  month10: "октября"
  month11: "ноября"
  month12: "декабря"
  day1: "Воскресенье"
  day2: "Понедельник"
  day3: "Вторник"
  day4: "Среда"
  day5: "Четверг"
  day6: "Пятница"
  day7: "Суббота"
  personal: "Личная благоприятность"
  haircut: "Стрижка"
  manicure: "Маникюр"
  travel: "Путешествия"
  clothes: "Надевание одежды"
  givecredit: "Давать в долг"
  takecredit: "Брать в долг"
</i18n>

<i18n locale="en" lang="yaml">
  noprediction: "No prediction"
  month1: "January"
  month2: "February"
  month3: "March"
  month4: "April"
  month5: "May"
  month6: "June"
  month7: "July"
  month8: "August"
  month9: "September"
  month10: "October"
  month11: "November"
  month12: "December"
  day1: "Sunday"
  day2: "Monday"
  day3: "Tuesday"
  day4: "Wednesday"
  day5: "Thursday"
  day6: "Friday"
  day7: "Saturday"
  haircut: "Haircut"
  manicure: "Manicure"
</i18n>
